RivalIQ.apps.Insights.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    collections.LinkedInPresences = Backbone.Collection.extend({
        model: App.models.LinkedInPresence,
        url: function () {
            return '/api/insights/linkedin/presences';
        }
    });
});
